import React from "react";

import alertSound from "assets/sounds/alert.mp3";

function useAlert() {
  const playQueue = React.useRef<{ createdAt: Date }[]>([]);
  const player = React.useMemo(() => {
    const audioPlayer = new Audio(alertSound);

    function playAudioPlayer() {
      audioPlayer.play();
    }

    function dequeue() {
      playQueue.current.shift();
      if (playQueue.current.length) {
        playAudioPlayer();
      }
    }

    audioPlayer.onended = dequeue;
    return audioPlayer;
  }, []);

  function enqueue() {
    playQueue.current.push({ createdAt: new Date() });
  }

  function run() {
    if (playQueue.current.length) {
      player.play();
    }
  }

  function play() {
    enqueue();
    run();
  }

  React.useEffect(() => {
    document.addEventListener("touchstart", run, true);
    document.addEventListener("touchend", run, true);
    document.addEventListener("click", run, true);
    document.addEventListener("keydown", run, true);
    return () => {
      document.removeEventListener("touchstart", () => null);
      document.removeEventListener("touchend", () => null);
      document.removeEventListener("click", () => null);
      document.removeEventListener("keydown", () => null);
    };
    // eslint-disable-next-line
  }, []);

  return { alert: play };
}

export default useAlert;
